import * as BrowserHistory from '../helpers/browserHistory';

export function update() {
    const $form = $('#searchform');
    const $showMoreLinks = $('.js-showmore,.js-shownomore');
    
    const pagings =
        $showMoreLinks
            .map((i, x) => $(x).data('countname') + '=' + $(x).data('offset'))
            .get()
            .join('&');

    const url = `${$form.attr('action')}?${$form.serialize()}&${pagings}`;

    BrowserHistory.replaceEntry(url);
}
